import {
  GET_SYSTEM_COUPONS_REQUEST,
  GET_SYSTEM_COUPONS_SUCCESS,
  GET_SYSTEM_COUPONS_FAILURE,
  RESET_SYSTEM_COUPONS
} from 'Store/constants';

const initialState = {
  data: [],
  isLoading: false,
  error: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_SYSTEM_COUPONS_REQUEST:
      return { ...state, isLoading: true, error: null };
    case GET_SYSTEM_COUPONS_SUCCESS:
      return { ...state, data: action.payload, isLoading: false, error: null };
    case GET_SYSTEM_COUPONS_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    case RESET_SYSTEM_COUPONS:
      return initialState;
    default:
      return state;
  }
};
